import { Component, Input, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent implements OnInit {
  @Input() uid: string = '';
  user: any;
  displaySrc = '';
  initial = '?';

  constructor(private afs: AngularFirestore) {}

  ngOnInit() {
    this.afs
      .collection('users')
      .doc(this.uid)
      .valueChanges()
      .subscribe((res: any) => {
        this.user = res;
        this.refreshAvatar();
      });
  }

  private refreshAvatar(): void {
    this.displaySrc = String(this.user?.logo || '').trim();
    this.initial = this.firstChar(
      this.user?.name,
      this.user?.fname,
      this.user?.lname
    );
  }

  private firstChar(
    name?: string | null,
    fname?: string | null,
    lname?: string | null
  ): string {
    const fromName = String(name || '').trim();
    if (fromName) {
      return fromName.charAt(0).toUpperCase();
    }
    const fromF = String(fname || '').trim();
    if (fromF) {
      return fromF.charAt(0).toUpperCase();
    }
    const fromL = String(lname || '').trim();
    if (fromL) {
      return fromL.charAt(0).toUpperCase();
    }
    return '?';
  }

  onImgError(): void {
    this.displaySrc = '';
  }
}
